import { Keypair } from "@solana/web3.js";
import { generateMnemonic, validateMnemonic, mnemonicToSeedSync } from "bip39";
import { derivePath } from "ed25519-hd-key";
import nacl from "tweetnacl";
import bs58 from "bs58";
import { ethers } from "ethers";

type Chain = "solana" | "ethereum";

class Wallet {
	derivationPath: string;
	chain: Chain;

	constructor(chain: Chain, index: number = 0) {
		this.derivationPath = `m/44'/${chain == "solana" ? 501 : 60}'/0'/${index}'`;
		this.chain = chain;
	}

	static generateRandom() {
		return generateMnemonic();
	}

	static validate(mnemonic: string) {
		return validateMnemonic(mnemonic);
	}

	importWallet(mnemonic: string) {
		const seed = mnemonicToSeedSync(mnemonic);
		const derivedSeed = derivePath(this.derivationPath, seed.toString("hex")).key;

		if (this.chain === "ethereum") {
			const privateKey = Buffer.from(derivedSeed).toString("hex");
			const wallet = new ethers.Wallet(privateKey);

			return { privateKey, publicKey: wallet.address };
		} else {
			const secret = nacl.sign.keyPair.fromSeed(derivedSeed).secretKey;
			const keypair = Keypair.fromSecretKey(secret);

			return { privateKey: bs58.encode(secret), publicKey: keypair.publicKey.toBase58() };
		}
	}
}

export default Wallet;
